import { render, staticRenderFns } from "./SubEvents.vue?vue&type=template&id=73566a63&scoped=true"
import script from "./SubEvents.vue?vue&type=script&lang=js"
export * from "./SubEvents.vue?vue&type=script&lang=js"
import style0 from "./SubEvents.vue?vue&type=style&index=0&id=73566a63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73566a63",
  null
  
)

export default component.exports